<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-accounts-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                         (detailSaved)="modal.close($event)"
                         (detailCancelled)="modal.dismiss()">
    </app-accounts-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-accounts-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                       [disabledButtons]="localDisabledButtons" [disabledColumns]="disabledColumns"
                       [filters]="filters" [disableRouterLink]="true">
    </app-accounts-list>
  </ng-template>
</div>